import React, { useState, useEffect } from 'react';
import QAViewer from './QAViewer';
import TabViewer from './TabViewer';
import InfoViewer from './Info_Viewer';
import RowViewer from './RowViewer';
import RandomizeViewer from './RandomizeViewer';
import IdentifierViewer from './IdentifierViewer';
import { WidgetTypes } from '../../../constants/QuestionTypes';
import DataTableViewer from './DataTableViewer';
import FilterViewer from './FilterViewer';
import REDCapSurveyViewer from './REDCapSurveyViewer';
import DisplayEditInfoViewer from './DisplayEditInfoViewer';
import ButtonViewer from './ButtonViewer';
import VideoViewer from './VideoViewer';
import MDHDataViewer from './MDHDataViewer';

const WidgetViewer = ({ Widget, Form_ID, Form_BehaviorOnLoad, Form_BehaviorOnSave, Question_Number,OnUpdate,
	SurveyMode, PrimaryKey, PK_Name, Project_ID, LightMode, FilterParametersList, onSubmitFilterParameters,
	selectedInstitution, Response, Form_SecondaryIDName, Form_SecondaryIDValue, Custom_Save, widgetsQA, preloadFormData,
	dataElements, infoConfig, sharedDataElement, resultSource, source, reloadForm, closePopUpForm, disabled, refreshWidget,
	handleRefreshWidget, FormWidgets, updateFormMDH, saveSurveyResponseWithMDH, updateRowColumns}) => {
	const handleSubmitFilterParameters = (SubmittedFilteredParametersList) => {
		onSubmitFilterParameters(SubmittedFilteredParametersList);
	};

	const [triggerRender, settriggerRender] = useState(false),
		  [selectedInst, setselectedInst] = useState(selectedInstitution),
		  [Responses, setResponses] = useState(Response);

	return (
			<div>
			{Widget.Widget_Type_ID === WidgetTypes.QA &&
				<QAViewer
					key={Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					Form_BehaviorOnLoad={Form_BehaviorOnLoad}
					Form_BehaviorOnSave={Form_BehaviorOnSave}
					Question_Number={Question_Number}
					OnUpdate={OnUpdate}
					SurveyMode={SurveyMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					selectedInst={selectedInst}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
					widgetsQA={widgetsQA}
					preloadFormData={preloadFormData}
					Question_ID={
						widgetsQA.some(w => w.Widget_ID === parseInt(Widget.Widget_ID)) &&
						widgetsQA.find(w => w.Widget_ID === parseInt(Widget.Widget_ID)).Question_ID
					} //Test for other projects
					disabled={disabled}
					Responses={Responses}
					refreshWidget={refreshWidget}
					handleRefreshWidget={handleRefreshWidget}
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.Tabs &&
				<TabViewer
					key={triggerRender}
					PrimaryKey={PrimaryKey}
					PK_Name={PK_Name}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					selectedInst={selectedInst}
					Responses={Responses}
					Question_Number={Question_Number}
					SurveyMode={SurveyMode}
					Project_ID={Project_ID}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
					source={source}
					closePopUpForm={closePopUpForm ? closePopUpForm : undefined}
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.DataTable && (
				<DataTableViewer
					key={'V' + Widget.Widget_ID}
					Form_ID={Form_ID}
					Widget_ID={Widget.Widget_ID}
					LightMode={LightMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					FilterParametersList={FilterParametersList}
					selectedInst={selectedInst}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
				/>
			)}

			{Widget.Widget_Type_ID == WidgetTypes.Info &&
				<InfoViewer
					key={Widget.Widget_ID}
					Project_ID={Project_ID}
					Widget_ID={Widget.Widget_ID}
					Widget_Color={Widget.Widget_Color}
					Widget_Type_ID={Widget.Widget_Type_ID}
					Form_ID={Form_ID}
					selectedInst={selectedInst}
					dataElements={dataElements}
					infoConfig={infoConfig}
					sharedDataElement={sharedDataElement}
					resultSource={resultSource}
					Col_ID={Widget.Widget_ID}
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.Button &&
				<ButtonViewer
					key={Widget.Widget_ID} 
					Project_ID={Project_ID}
					Form_ID={Form_ID} 
					Widget_ID={Widget.Widget_ID} 
					PrimaryKey={PrimaryKey}
					Widget_Color={Widget.Widget_Color}
					Custom_Save={Custom_Save}
					selectedInst={selectedInst}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
					reloadForm={reloadForm}
					closePopUpForm={closePopUpForm ? closePopUpForm : undefined}
					disabled={disabled}
				/>
			}

			{/* Randomize Button Widget: Reuse Info widget content */}
			{Widget.Widget_Type_ID === WidgetTypes.Randomize &&
				<RandomizeViewer 
					key={'V' + Widget.Widget_ID} 
					Project_ID={Project_ID}
					Form_ID={Form_ID} 
					Widget_ID={Widget.Widget_ID} 
					Widget_Type_ID={Widget.Widget_Type_ID} 
					PrimaryKey={PrimaryKey}
					SurveyMode={SurveyMode}
					buttonColor='#4BB543'
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.Row &&
				<RowViewer
					key={Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					Question_Number={Question_Number}
					OnUpdate={OnUpdate}
					SurveyMode={SurveyMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					selectedInst={selectedInst}
					Form_BehaviorOnLoad={Form_BehaviorOnLoad}
					Form_BehaviorOnSave={Form_BehaviorOnSave}
					Form_SecondaryIDName={Form_SecondaryIDName}
					Form_SecondaryIDValue={Form_SecondaryIDValue}
					widgetsQA={widgetsQA}
					preloadFormData={preloadFormData}
					dataElements={dataElements}
					infoConfig={infoConfig}
					sharedDataElement={sharedDataElement}
					resultSource={resultSource}
					Custom_Save={Custom_Save}
					reloadForm={reloadForm}
					closePopUpForm={closePopUpForm ? closePopUpForm : undefined}
					disabled={disabled}
					Responses={Responses}
					refreshWidget={refreshWidget}
					handleRefreshWidget={handleRefreshWidget}
					FormWidgets={FormWidgets}
					columnsDisabled={Widget.Columns_Disabled}
					updateRowColumns={updateRowColumns}
					columnsHidden={Widget.columnsHidden}
				/>
			}

			{Widget.Widget_Type_ID === WidgetTypes.Filter && (
				<FilterViewer key={'V' + Widget.Widget_ID} Widget_ID={Widget.Widget_ID} Form_ID={Form_ID} FilterParametersList={FilterParametersList} onSubmitFilterParameters={handleSubmitFilterParameters} />
			)}

			{Widget.Widget_Type_ID === WidgetTypes.Identifier && (
				<IdentifierViewer
					key={triggerRender}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					Question_Number={Question_Number}
					OnUpdate={OnUpdate}
					SurveyMode={SurveyMode}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}
			{/* REDCap Preview */}
			{Widget.Widget_Type_ID === WidgetTypes.REDCapForm && (
				<REDCapSurveyViewer
					key={'V' + Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}

			{Widget.Widget_Type_ID === WidgetTypes.DisplayEditInfo && (
				<DisplayEditInfoViewer
					key={'V' + Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}

			{Widget.Widget_Type_ID === WidgetTypes.Video && (
				<VideoViewer
					key={'V' + Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
				/>
			)}

			{Widget.Widget_Type_ID === WidgetTypes.MDHData && (
				<MDHDataViewer
					key={'V' + Widget.Widget_ID}
					Widget_ID={Widget.Widget_ID}
					Form_ID={Form_ID}
					PrimaryKey={PrimaryKey}
					Project_ID={Project_ID}
					updateFormMDH={updateFormMDH}
					saveSurveyResponseWithMDH={saveSurveyResponseWithMDH}
				/>
			)}
		</div>
	);
};

export default WidgetViewer;
